import { InjectionToken } from '@angular/core';

export interface Address {
  addressId?: string;
  unitNum?: string;
  streetNumSuffixVal?: string;
  unitTypeCd?: string;
  streetNum?: string;
  streetName: string;
  streetType?: string;
  streetDirection?: string;
  poBox?: string;
  cityName: string;
  postalCode: string;
  territory: string;
  territoryCd?: string;
  country?: string;
  countryCd?: string;
  addressLine?: Array<string>;
  ruralRouteNum?: string;
  ruralRouteTypeCd?: string;
  postalStationTxt?: string;
}

export interface CfrConfig {
  addressCompleteKey: string;
  addressCompleteURL: string;
}

export const CFR_CONFIGURATION = new InjectionToken('cfrConfiguration');
